import $http from '@/api/index'

/*方法说明
 *@method 方法名
 *@for 所属类名
 *@param{参数类型}参数名 参数说明
 *@return {返回值类型} 返回值说明
 */
export function test(name, password) {
  let getUrl = {
    method: 'GET',
    url: '/xx/yy',
  }
  let params = {

  }
  return $http(getUrl, params)
}
/*获取所有组织机构tree
 *@method GetAllCompanyExDeptTree
 *@return 所有组织机构
 */
export function GetAllCompanyExDeptTree(userId, keyWord, tag) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllCompanyExDeptTree1',
    requestType: 2
  }
  let params = {
    userId: userId,
    keyword: keyWord,
    tag: tag
  }
  if (userId == '') {
    params.userId = "super"
  }
  if (tag == '') {
    params.tag = 0
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  return $http(getUrl, params)
}
//发布身份
export function GetAllUserAndCompanyExDeptTree() {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllUserAndCompanyExDeptTree',
    requestType: 2
  }
  let params = {}
  return $http(getUrl, params)
}
/*获取所有机构
 *@method getCompanyList
 *@return 所有机构
 */
export function getCompanyList(val, ID) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllCustomerVWInfo',
    requestType: 2
  }
  let params = {
    userId: ID,
    keyword: val,
    isEnableAuthority: true,
    companyType: "1,2,3"
  }
  if (ID == '') {
    params.userId = 'super'
  }
  return $http(getUrl, params)
}
/*按类型获取所有组织机构
 *@method getCompanyByType
 *@return 所有机构
 */
export function getCompanyByType(userId, keyWord, tag) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCompanyExTypeCompanyExTree',
    requestType: 2
  }
  let params = {
    userId: userId,
    ctype: -1,
    includeBrand: true,
    keyword: keyWord,
    tag: tag
  }
  if (userId == '') {
    params.userId = 'super'
  }
  if (keyWord != '') {
    params.keyword = keyWord
  }
  if (tag == '') {
    params.tag = 0
  }
  return $http(getUrl, params)
}
/*选择特定机构下人员
 *@method getUserByCompany
 *@return 人员
 */
export function getUserByCompany(userId, companyExId) {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetCompanyDeptUserTree',
    requestType: 2
  }
  let params = {
    userId: userId,
    companyExId: companyExId
  }
  if (userId == '') {
    params.userId = 'super'
  }
  return $http(getUrl, params)
}
/*选择特定机构下人员
 *@method getUserByCompany
 *@return 人员
 */
export function getAllUser() {
  let getUrl = {
    method: 'GET',
    url: 'basedata/GetAllCompanyDeptUserTree',
    requestType: 2
  }
  let params = {
    userId: 'super',
  }
  return $http(getUrl, params)
}
/*获取所有功能间
 *@method GetFuncRoomByCompanyId
 *@return 功能间集合
 */
export function GetFuncRoomByCompanyId(companyId, keyWord) {
  let getUrl = {
    method: 'GET',
    url: 'user/GetFuncRoomByCompanyId',
    requestType: 2
  }
  let params = {
    companyId: companyId,
    keyWord: keyWord
  }
  return $http(getUrl, params)
}
/*获取特定科室功能间
 *@method GetFuncRoomByCompanyId
 *@return 功能间集合
 */
export function GetFuncRoomByDeptId(deptId) {
  let getUrl = {
    method: 'GET',
    url: 'user/GetFuncRoomByDeptId',
    requestType: 2
  }
  let params = {
    deptId: deptId
  }
  return $http(getUrl, params)
}
export function testQs(test1) {
  let options = {
    method: 'GET',
    url: 'user/GetFuncRoomByCompanyId',
    requestType: 2
  }
  let params = {
    companyId: '',
    keyword: test1
  }
  return $http(options, params)
}
/*
 * 查找所有服务台
 */
export function GetAllServerCenter(keyword) {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllServerCenter',
    requestType: 2
  }
  let params = {
    keyword: keyword
  }
  return $http(options, params)
}
/*
 * 查找所有机构
 */
export function GetAllCustomerVWInfo(val) {
  let options = {
    method: 'GET',
    url: 'user/GetAllCustomerVWInfo',
    requestType: 2
  }
  let params = {
    isRight: false,
    input: val ? val : ''
  }
  return $http(options, params)
}
/*
 * 查找特定机构下组织
 */
export function GetListDeptByCompanyExId(userId, companyExId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetListDeptByCompanyExId',
    requestType: 2
  }
  let params = {
    userId: userId,
    companyExId: companyExId
  }
  return $http(options, params)
}
/*
 * 获取岗位数据
 */
export function GetListPostInfo() {
  let options = {
    method: 'GET',
    url: 'basedata/GetListPostInfo',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

/*
 * 根据搜索条件搜索人员,模板基础控件使用
 */
export function GetTemplateUserSearchResult(params) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateUserSearchResult',
    requestType: 2
  }
  return $http(options, params)
}
//根据人员或者联系人ID，获取对应的人员或者联系人
export function GetTemplateUserResultByListUserID(listUserId, userId) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateUserResultByListUserID',
    requestType: 2
  }
  let params = {
    listUserId,
    userId
  }
  return $http(options, params)
}

//人员管理分页

export function GetTemplateUserSearchResultCount(queryData) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateUserSearchResultCount',
    requestType: 2
  }
  let params = queryData;
  return $http(options, params)
}

//人员管理分页(新版)

export function GetNewEmergencyUserSearchResultCount(queryData) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetNewEmergencyUserSearchResultCount',
    requestType: 11
  }
  let params = queryData;
  return $http(options, params)
}
/*
 * 根据搜索条件搜索人员,模板基础控件使用
 */
export function GetTemplateUserSearchResultByTemplateID(templateId, currentUserId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateUserSearchResultByTemplateID',
    requestType: 2
  }
  let params = {
    templateId: templateId,
    currentUserId: currentUserId
  }
  return $http(options, params)
}
/*
 * 根据搜索条件搜索人员,模板基础控件使用(新版)
 */
export function GetNewEmergencyUserSearchResultCountByTemplateId(params) {
  let options = {
    method: 'GET',
    url: 'emergencybasedata/GetNewEmergencyUserSearchResultCountByTemplateId',
    requestType: 11
  }
  return $http(options, params)
}

/*
 * 根据条件搜索我管理的团队
 */
export function GetTemplateTeamSearchResult(params) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateTeamSearchResult',
    requestType: 2
  }
  return $http(options, params)
}

/*
 * 根据左侧的模板ID，获取搜索的计算机集合，模板可以是结果集模板也可以是搜索模板。
 */
export function GetTemplateTeamSearchByTemplateID(templateId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateTeamSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId: templateId
  }
  return $http(options, params)
}

/*
 * 根据条件搜索机构组织
 */
export function GetTemplateCompanyDeptSearchResult(params) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateCompanyDeptSearchResult',
    requestType: 2
  }
  return $http(options, params)
}

/*
 * 根据左侧的模板ID，获取搜索的机构组织，模板可以是结果集模板也可以是搜索模板。
 */
export function GetTemplateCompanyDeptSearchByTemplateID(templateId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateCompanyDeptSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId: templateId
  }
  return $http(options, params)
}

export function GetTemplateUserResultByListId(listUserId) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateUserResultByListId',
    requestType: 2
  }
  let params = {
    listUserId: listUserId
  }
  return $http(options, params)
}

export function AddTemplateSearchLog(mainType, secondType, userId, socialId) {
  let options = {
    method: 'GET',
    url: 'basedata/AddTemplateSearchLog',
    requestType: 2
  }
  let params = {
    mainType,
    secondType,
    userId,
    socialId
  }
  return $http(options, params);
}

export function GetTemplateTeamSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateTeamSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}

export function GetTemplateCompanyDeptSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateCompanyDeptSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}
export function GetTemplateProductCodeSearchResultByTemplateID(templateId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateProductCodeSearchResultByTemplateID',
    requestType: 2
  }
  let params = {
    templateId
  }
  return $http(options, params);
}
export function GetTemplateLocationSearchByTemplateID(templateId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateLocationSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId
  }
  return $http(options, params);
}
export function GetTemplateProductCodeSearchResult(params) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateProductCodeSearchResult',
    requestType: 2
  }
  return $http(options, params);
}
export function GetTemplateProductCodeSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateProductCodeSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}
export function GetTemplateLocationSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateLocationSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}
export function GetTemplateLocationSearchResult(params) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateLocationSearchResult',
    requestType: 2
  }
  return $http(options, params);
}

export function GetTemplateUserSearchByCount(userId, isContainContact = false) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateUserSearchByCount',
    requestType: 2
  }
  let params = {
    userId,
    isContainContact
  }
  return $http(options, params);
}
//获取计算机相关的搜索结果集合
export function GetPubHostListBySearchPamaWeb(pageIndex, pageSize, strPara) {
  let options = {
    method: 'GET',
    url: 'basedata/GetPubHostListBySearchPamaWeb',
    requestType: 2
  }
  let params = {
    pageindex: pageIndex,
    pagesize: pageSize,
    pamaweb: strPara
  }
  return $http(options, params);
}
export function GetPubHostListSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetPubHostListSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}

export function GetTemplateHostSearchByTemplateID(templateId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateHostSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId
  }
  return $http(options, params);
}

export function GetHostManufacuterList() {
  let options = {
    method: 'GET',
    url: 'TMS/GetHostManufacuterList',
    requestType: 2
  }
  let params = {

  }
  return $http(options, params);
}

export function GetFuncRoomByListDeptId(deptids) {
  let options = {
    method: 'GET',
    url: 'basedata/GetFuncRoomByListDeptId',
    requestType: 2
  }
  let params = {
    deptids
  }
  return $http(options, params);
}

export function updatePwd(code, password) {
  const options = {
    method: 'POST',
    url: 'user/ModifyPassword',
    requestType: 2
  }
  const params = {
    code: code,
    password: password
  }
  return $http(options, params)
}

export function GetAllReciversByServerCenterIds(serverCenterIds) {
  let getUrl = {
    method: 'GET',
    url: `user/GetAllReciversByServerCenterIds`,
    requestType: 2
  }
  let params = {
    serverCenterIds: serverCenterIds,
    input: ""
  }
  return $http(getUrl, params)
}
export function GetCompanyExByDeptId_New(deptId) {
  let getUrl = {
    method: 'GET',
    url: `user/GetCompanyExByDeptId_New`,
    requestType: 2
  }
  let params = {
    deptId: deptId
  }
  return $http(getUrl, params)
}
